import { FC } from 'react';
import { useBraze } from 'modules/push-notification';
import {
  CaptionedImageCardProps,
  ClassicCardProps,
  ContentCardProps,
  ImageOnlyCardProps
} from '../types';
import { CaptionedImageCard } from './CaptionedImageCard';
import { ClassicCard } from './ClassicCard';
import { ImageOnlyCard } from './ImageOnlyCard';

export const CustomContentCard: FC<ContentCardProps> = props => {
  const { card } = props;
  const braze = useBraze();

  // Don't render control cards or dismissed cards
  if (card.isControl || card.dismissed) return null;

  // Check if card is expired
  if (card.expiresAt && Date.now() > new Date(card.expiresAt).getTime())
    return null;

  if (!braze) return null;

  if (card instanceof braze.ClassicCard) {
    return <ClassicCard {...(props as ClassicCardProps)} />;
  }
  if (card instanceof braze.CaptionedImage) {
    return <CaptionedImageCard {...(props as CaptionedImageCardProps)} />;
  }
  if (card instanceof braze.ImageOnly) {
    return <ImageOnlyCard {...(props as ImageOnlyCardProps)} />;
  }

  return null;
};
